import { createAction } from "typesafe-actions";
import { TimesheetEntry, ExportedTimesheetEntry } from "../types";
import { AppState } from "./types";

const actions = {
  import: createAction("IMPORT")<{
    sheetName?: string;
    newSheet: boolean;
    entries: ExportedTimesheetEntry[];
  }>(),
  createSheet: createAction("CREATE_SHEET")<{
    sheetName?: string;
  }>(),
  changeSheet: createAction("CHANGE_SHEET")<{
    entries: TimesheetEntry[];
    sheetName: string;
  }>(),
  removeSheet: createAction("REMOVE_SHEET")<{ sheetName: string }>(),
  create: createAction("CREATE")<CreateEntryParams>(),
  load: createAction("LOAD")<Partial<AppState>>(),
  update: createAction("UPDATE")<{
    entry: Pick<TimesheetEntry, "id">;
    updatedEntry: Pick<TimesheetEntry, "description" | "duration" | "start">;
  }>(),
  remove: createAction("REMOVE")<TimesheetEntry>(),
  renameSheet: createAction("RENAME_SHEET")<string>()
};

export default actions;

type CreateEntryParams = Pick<
  TimesheetEntry,
  "description" | "duration" | "start"
>;
